export default {
    errorMessage: 'เกิดข้อผิดพลาด',
    somethingWrong: 'เกิดข้อผิดพลาด!!',
    close: 'ปิด'
}
